import Swal from 'sweetalert2'

const alert = Swal.mixin({})

export const Alert = (success = true, message = '', duration = 6000) => {
    let type
    if (typeof success === 'boolean') {
        type = success ? 'success' : 'error'
    } else {
        type = success
    }

    alert.fire({
        icon: type,
        title: message,
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: duration,
        timerProgressBar: true,
        iconColor: 'white',
        customClass: {
            popup: 'vn-toast-popup',
            container: 'vn-toast',
        },
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
            toast.addEventListener('click', Swal.close)
        },
    })
}



document.addEventListener("DOMContentLoaded", function () {
    const readMoreButton = document.querySelector('.read-more');
    const offset = 100;

    if (readMoreButton) {
        readMoreButton.addEventListener('click', function (e) {
            e.preventDefault();
            const target = document.querySelector('.scroll-content');
            if (target) {
                let offset = 100;
                let targetPosition = target.offsetTop - offset;
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
                event.preventDefault();
            }
        });
    }
});
